import {CartProductView} from './cart-product';
import { CartSampleView } from './cart-sample';
// import { noCartProductTemplate, noCartSamplesTemplate, cartSummaryTemplate, cartEmptyTemplate } from '../templates';

var CartPage = Backbone.View.extend({
    events: {
        'click a.toggle-checkout' : 'toggleCheckoutView',
        'click .keep-shopping' : 'keepShopping'
        // 'click a.test-send': 'testSend',
    },
    initialize: function(){
        this.cartStringLines = [];
        this.sampleStringLines = [];

        this.cartEmptyTemplate = document.getElementById('cart-empty-template').innerHTML;
        this.cartSummaryTemplate = _.template(document.getElementById('cart-summary-template').innerHTML );
        this.noCartSamplesTemplate = _.template(document.getElementById('empty-cart-samples-template').innerHTML );
        this.noCartProductTemplate = _.template(document.getElementById('empty-cart-products-template').innerHTML );
        
        _.bindAll( this, 
            'render', 
            'updateCartSummary', 
            'customGtag', 
            'makeCartItemslist', 
            'makeSamplesItemslist', 
            'addProduct', 
            'addProducts', 
            'addSamples', 
            'addSample', 
            'toggleCheckoutView', 
            'onFormSubmitted', 
            'makeCartDetails', 
            'addProductString', 
            'addSampleString',
            'keepShopping'
            // 'testSend',
            // 'sendToNotifier'
        );
        this.rendered = false;
        this.listenTo( this.model, 'change', this.render );
    },
    render: function(){
        if ( this.model.get( 'count' ) ) { 
            this.addProducts();
            this.addSamples();
            this.renderForm();
            this.updateCartSummary();
            this.rendered = true;
        } else {
            this.$el.html( this.cartEmptyTemplate );
        }
    },
    /**
     * keepShopping
     * 
     * send the user back one step in their history to continue shopping.
     * 
     * @param {event} e 
     * @returns false
     */
    keepShopping: function(e ){
        e.preventDefault();
        window.history.go(-1); 
        return false;
    },
    /**
     * toggleCheckout
     * 
     * show or hide the checkout form
     * 
     * @param {event} e 
     */
    toggleCheckoutView: function( e ){
        e.preventDefault();
        this.updateCartSummary();
        this.$el.toggleClass( 'show-checkout' );
        this.el.scrollIntoView();
    },
    /**
     * renderForm
     * 
     * render the hubspot form
     */
    renderForm: function(){
        if ( !this.rendered ) {
            if ( typeof window.hbspt !== 'undefined' ) {
                var x = new Date();
                var secs = x.getTime();

                // see: https://legacydocs.hubspot.com/docs/methods/forms/advanced_form_options
                window.hbspt.forms.create({
                    region: "na1",
                    portalId: "1843383",
                    formId: "228f7b06-b8a5-410a-828f-96fccab859e5", 
                    target: '#grcc-request-cart-form',
                    formInstanceId: 'request-form-' + secs,
                    submitButtonClass: 'btn checkout-submit',
                    onFormSubmitted : this.onFormSubmitted,
                    onBeforeFormSubmit: this.makeCartDetails,
                    onFormReady:  this.makeCartDetails
                });
            } else {
                console.warn( 'hbspt library is missing' );
            }
        }
        // this.makeCartDetails();
    },
    /**
     * onFormSubmitted
     * 
     * after the form is submitted, we might as well clear our cart 
     * and stop listening to changes of that cart.
     */
    onFormSubmitted: function( ){

        // we could send these from here to an API endpoint 
        // to send the email with our server instead of relying on hubspot, 
        // which I don't believe is going to be possible.

        //console.log( $form, values );

        // this.sendToNotifier( values );

        this.stopListening( this.model, 'change', this.render );
        this.emptyCart();
    },
    /**
     * emptyCart
     * 
     * clear out the cart contents.
     */
    emptyCart: function(){
        this.$( '.cart-view' ).remove();
        this.$( 'a.toggle-checkout' ).remove();
        var summary = this.$('.summary-details').html()
        this.$('.summary-details').html( summary.replaceAll( 'are requesting', 'requested' ) );
        window.cart.clearCart();
        window.scrollTo(0,0);
    },
    /**
     * customGtag
     * potentially add items to the datalayer for analytics, 
     * NOT currently in use and may be able to be removed.
     */
    customGtag: function(){
        if ( typeof window.dataLayer !== 'undefined' ) {
            window.dataLayer.push(arguments);
        }
    },
    /**
     * makeCartItemslist
     * 
     * generate a text string of the cart content to send along to hubspot
     * 
     * @returns cartString (str)
     */
    makeCartItemslist: function(){
        this.cartStringLines = [];
        var products = this.model.get( 'products' );
        if ( products.length ) {
            this.cartStringLines.push('PRODUCTS');
            this.cartStringLines.push('--------');

            products.each(this.addProductString);
        }

        var cartString = this.cartStringLines.join( "\n" );
        return cartString;
    },
     /**
     * makeSamplesItemslist
     * 
     * generate a text string of the sample content to send along to hubspot
     * 
     * @returns cartString (str)
     */
     makeSamplesItemslist: function(){
        this.sampleStringLines = [];
        var samples = this.model.get( 'samples' );
        if ( samples.length ) {
            this.sampleStringLines.push('SAMPLES');
            this.sampleStringLines.push('--------');

            samples.each(this.addSampleString);
            
        }

        var sampleString = this.sampleStringLines.join( "\n" );
        return sampleString;
    },
    /**
     * updateCartSummary
     * 
     * generate information from the cart to show to the user at the top of the checkout form
     */
    updateCartSummary: function(){
        console.log( this.model.toJSON() );
        var products = this.model.get( 'products' );
        var samples = this.model.get( 'samples' );
        var summary = this.cartSummaryTemplate({ 'product_count': products.length, 'sample_count': samples.length });
        this.$('.summary-details').html( summary );
    },
    /**
     * makeCartDetails
     * 
     * get the cart items list and add it to the search query input
     * 
     * @param {object/element} form 
     */
    makeCartDetails: function( form ){

        var cartString = this.makeCartItemslist();
        this.$('input[name="customizer_quote_request_products"]', form ).val( cartString );

        if ( cartString.length ) {
            this.$('input[name="new_product_quote_request"]', form ).val(true);
        } else {
            this.$('input[name="new_product_quote_request"]', form ).val(false);
        }

        var sampleString = this.makeSamplesItemslist();
        this.$('input[name="samples_request"]', form ).val( sampleString );

        if ( sampleString.length ) {
            this.$('input[name="new_samples"]', form ).val(true);
        } else {
            this.$('input[name="new_samples"]', form ).val(false);
        }

    },
    /**
     * addProductString
     * 
     * add an individual line item product to the cart string.
     * 
     * @param {model} prod 
     */
    addProductString: function( prod ) {
        this.cartStringLines.push( prod.get('name') );
        this.cartStringLines.push( 'SKU: ' + prod.get('sku') );
        this.cartStringLines.push( 'QTY: ' + prod.get('quantity') );

        var settings = prod.get( 'settings' );
        var settings_labels = prod.get( 'settings_labels' );
        var label = '';
        var val = '';
        for (var key in settings) {
            if (settings.hasOwnProperty(key)) {
                label = settings_labels[key] ? settings_labels[key] : key;
                val = settings[key];
                this.cartStringLines.push( label + ': ' + val  );
            }
        }

        this.cartStringLines.push( "\n" );
        
    },
    /**
     * addSampleString
     * 
     * add an individual line item sample to the cart string.
     * 
     * @param {model} sample 
     */
    addSampleString: function( sample ){
        this.sampleStringLines.push( sample.get('name') + ' (' + sample.get('finish_type') +')' );
    },
    /**
     * addSamples
     * 
     * add each sample from the collection.
     * if it is empty note that it is empty,
     * if it has already rendered, skip rendering again, 
     * new samples can't be added from this view, subviews will be updated
     * 
     * @returns VOID
     */
    addSamples: function(){

        var samples = this.model.get( 'samples' );
        this.$('.samples-count').text( '(' + samples.length  +')');

        if ( this.rendered && samples.length ) {
            return;
        }
        if ( samples.length ) {
            samples.each(this.addSample);
        } else {
            var empty = this.noCartSamplesTemplate({});

            this.$( '.cart-samples' ).html( empty );
        }
    },
    /**
     * addSample
     * 
     * add individual samples from the collection for each loop
     * @param {model} sample 
     */
    addSample: function( sample ){
        var sampleView = new CartSampleView({ model: sample });
        sampleView.render();
        this.$( '.cart-samples' ).append( sampleView.el );
    },
    /**
     * addProducts
     * 
     * add each product from the collection.
     * if it is empty note that it is empty,
     * if it has already rendered, skip rendering again, 
     * new products can't be added from this view, subviews will be updated
     * 
     * @returns VOID
     */
    addProducts: function(){

        var products = this.model.get( 'products' );
        this.$('.products-count').text( '(' + products.length  +')');
        if ( this.rendered && products.length ) {
            return;
        }
        if ( products.length ) {
            products.each(this.addProduct);
        } else {
            var empty = this.noCartProductTemplate({});

            this.$( '.cart-products' ).html( empty );
        }
    },
    /**
     * addProduct
     * 
     * add an individual product from the colleciton (callback for each loop)
     * 
     * @param {model|obj} prod 
     */
    addProduct: function( prod ){
        this.listenTo( prod, 'change', this.makeCartDetails );
        var productView = new CartProductView({ model: prod });
        productView.render();
        this.$( '.cart-products' ).append( productView.el );
    }
    // sendToNotifier: function( values ){
    //     values.customizer_quote_request_products = this.makeCartItemslist();
    //     values.samples_request = this.makeSamplesItemslist();

    //     // console.log( values );
    //     fetch( site_data.api_url_base + 'gr-chair/v1/quote-submission', {
    //         method: "POST",
    //         headers: {'Content-Type': 'application/json'}, 
    //         body: JSON.stringify(values)
    //     });

    // },
    // testSend: function( e  ){
    //     e.preventDefault();
    //     this.sendToNotifier({});
    // }
});

export {CartPage};